import { setEstimationExist, setMyHomeExists } from 'shared/actions/valuationTraps/actions';

export enum EGetMyHomeObjectsExists {
  setMyHomeExists = 'valuationTraps/set-my-home-exists',
  setEstimationExists = 'valuationTraps/set-estimation-exists',
}

export type TValuationTrapsActions = ReturnType<typeof setMyHomeExists> | ReturnType<typeof setEstimationExist>;
